module.exports = __webpack_public_path__ + "img/markdown-light-01.b1523f78.jpg";